import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function JobForm({ onJobAdded }) {
    const [videoUrl, setVideoUrl] = useState('');
    const [videoFile, setVideoFile] = useState(null);
    const [configName, setConfigName] = useState('default_video_generation_config');
    const [configOverrides, setConfigOverrides] = useState('{}');
    const [availableConfigs, setAvailableConfigs] = useState([]);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const fetchConfigs = async () => {
            try {
                const response = await axios.get('/api/configs/');
                setAvailableConfigs(Object.keys(response.data));
            } catch (err) {
                console.error("Error fetching configs:", err);
            }
        };
        fetchConfigs();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        if (!videoUrl && !videoFile) {
            setError('Please provide a video URL or upload a video file.');
            setIsSubmitting(false);
            return;
        }
        
        const formData = new FormData();
        if (videoUrl) formData.append('video_url', videoUrl);
        if (videoFile) formData.append('video_file', videoFile);
        formData.append('config_name', configName);
        formData.append('config_overrides', configOverrides);

        try {
            await axios.post('/api/job/add', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            onJobAdded();
            setVideoUrl('');
            setVideoFile(null);
            e.target.reset();
        } catch (err) {
            setError(err.response?.data?.error || 'An unexpected error occurred.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="form-container">
            <h2>Create New Job</h2>
            {error && <p className="error-message">{error}</p>}
            
            <div className="form-group">
                <label>Video URL</label>
                <input 
                    type="text" 
                    value={videoUrl}
                    onChange={(e) => setVideoUrl(e.target.value)}
                    disabled={!!videoFile}
                    placeholder="http://example.com/my_video.mp4"
                />
            </div>

            <div className="form-group">
                <label>Or Upload Video File</label>
                <input 
                    type="file" 
                    onChange={(e) => setVideoFile(e.target.files[0])}
                    disabled={!!videoUrl}
                />
            </div>
            
            <div className="form-group">
                <label>Configuration</label>
                <select value={configName} onChange={(e) => setConfigName(e.target.value)}>
                    {availableConfigs.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
            </div>

            <div className="form-group">
                <label>Config Overrides (JSON)</label>
                <textarea 
                    value={configOverrides}
                    onChange={(e) => setConfigOverrides(e.target.value)}
                    style={{ fontFamily: 'monospace' }}
                />
            </div>

            <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Add Job'}
            </button>
        </form>
    );
} 